// extracted by mini-css-extract-plugin
export var card = "_57-0";
export var content = "_57-1";
export var contentLoading = "_57-2";